const PartnerEntity = (client) => ({
  create: async (data) => await client.post(`/api/partners`, data),
  update: async (id, data) => await client.put(`/api/nodes/${id}`, data),
  destroy: async (id) => await client.delete(`/api/partners/${id}`),
})

export default PartnerEntity
